
import { Presentation } from "../../../dev/gameflow/controller/Presentation";
import { StateHandler } from "../../../dev/utils/StateHandler";
import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { GameData } from "../../server/data/BaseModel";
import { ArrayHelper } from '../../../dev/utils/ArrayHelper';
import { RoadRage } from '../../RoadRage';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';

class mysteryStates extends StateHandler {
    public static MYSTERY: string = "mystery";
    public static DONE: string = "done";
}

export class MysteryPresentation extends Presentation {

    private gameData: GameData;
    private state: mysteryStates = new mysteryStates();

    private mysteryPos: number[] = [];
    private mysteryValues: string[] = [];
    private startFSSpins: number = 0;

    setGamedData(data: GameData): void {
        this.gameData = data;

        this.mysteryPos = data.Reel.mysteryPos;
        this.mysteryValues = data.Reel.MysteryRevealValue;

        this.startFSSpins = Math.max(0, data.raw.freespinsLeft - data.fsInfo.addedNumberOfFreespinsThisSpin!);
    }

    preStart(): void {
        this.state.set(mysteryStates.MYSTERY);
    }

    checkForActivation(data: GameData) {
        return data.isFreeSpin && !!data.Reel.gotMystery;
    }

    createPresentation(enableSkip: Function) {
        enableSkip(false);

        switch (this.state.value) {
            case mysteryStates.MYSTERY:
                this.mystery();
                this.state.set(mysteryStates.DONE);
                break;
            default:
                this.PresentationState.setInactive();
        }

        if (this.timeline.totalDuration() > 0)
            this.timeline.to(this, { duration: 0.8 })
    }

    mystery(): void {
        let delay: number = 0;
        let animStart: number = 0;

        let carGot: boolean = false;
        this.mysteryPos.forEach((mPos: number, reel: number) => {
            if (mPos == -1) return;
            if (RoadRageEngineManager.getReel(reel).getSymbol(mPos)?.isCar) return;
            let revealValue = this.mysteryValues[reel];
            carGot = false;

            this.timeline.add(RoadRageEngineManager.getReel(reel).getSymbol(mPos)?.changeMysteryValue(revealValue)!);

            animStart = this.timeline.duration();
            const CarsAffected: number[][] = this.getCarsPos(revealValue[3]);
            CarsAffected.forEach((v, i) => CarsAffected[i] = CarsAffected[i].filter((vk, ik, ar) => { return ar.indexOf(vk) === ik }))
            CarsAffected.forEach(v => { if (v.length > 0) carGot = true; });

            const boxGot = (this.gameData.Reel.CarsFSAvailable.indexOf(revealValue.slice(1, 4).toString()) >= 0);

            this.timeline.add(() => {
                for (let reel: number = 0; reel < CarsAffected.length; reel++) {
                    for (let indx: number = 0; indx < CarsAffected[reel].length; indx++) {
                        RoadRageEngineManager.getReel(reel).getSymbol(CarsAffected[reel][indx])?.addMult(1, revealValue.slice(1, 4), true);
                    }
                }
            }, animStart + delay)

            this.timeline.add(() => {
                if(boxGot){
                    SoundManager.playSoundEffect(SoundConfig.SETUP_CAR_PLUS_CAR);
                    RoadRage.overlayAnim.playPlusBox(
                        RoadRageEngineManager.getReel(reel).getSymbol(mPos)!,
                        RoadRage.bgOverlay.fetchBoxBytype(revealValue.slice(1)),1,false,revealValue.slice(1));
                    RoadRage.bgOverlay.fetchBoxBytype(revealValue.slice(1, 4)).multValue += 1;
                } 
            }, animStart + delay)

            if (!boxGot && !carGot) {
                this.timeline.add(() => {
                    this.startFSSpins += 1;
                    SlotGame.keypadPlugin.setZeroBetSpinCounter(this.startFSSpins);
                    RoadRage.overlayAnim.playPlusOneFS(RoadRageEngineManager.getReel(reel).getSymbol(mPos)!, 1);
                }, animStart + delay);
                this.timeline.add(() => { SoundManager.playSoundEffect(SoundConfig.PLUS_ONE_FREESPIN) }, animStart + delay)
            }
            delay += 0.1;
        });

        this.timeline.to(this, { duration: carGot ? 0.5 : 0 })
    }

    private getCarsPos(type: string): number[][] {
        const temp: number[][] = ArrayHelper.initArrayWithValues(this.gameData.Reel.reels.length, () => []);
        this.gameData.Reel.stickWildPos.filter(v => v.type === "WC" + type).forEach((v) => temp[v.reel].push(v.row))
        if(type === "1" || type === "2"){
            RoadRageEngineManager.RSWindow((rc,s) => { if(s.symName === "WC4") temp[rc.reelID].push(s.posID[0]) })
        }
        switch (type) {
            case "1":
                temp.forEach((v, i) => {
                    RoadRageEngineManager.RSWindow((rc,s) => { if(s.symName === "WC1") temp[rc.reelID].push(s.posID[0]) })
                });
                return temp;
            case "2":
                temp.forEach((v, i) => {
                    RoadRageEngineManager.RSWindow((rc,s) => { if(s.symName === "WC2") temp[rc.reelID].push(s.posID[0]) })
                });
                return temp;
            case "3":
                temp.forEach((v, i) => {
                    RoadRageEngineManager.RSWindow((rc,s) => { if(s.symName === "WC3") temp[rc.reelID].push(s.posID[0]) })
                });
                return temp;
            default:
                return temp;
        }
    }


    done(): void {
    }
}